import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Seo from '../components/Seo';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Seo
        title={t('notfound.seo.title')}
        description={t('notfound.seo.description')}
        path="/404"
        noindex
      />
      <Header />
      <main
        className="flex-1 flex items-center justify-center px-6 py-24"
        data-testid="not-found-page"
      >
        <div className="text-center max-w-xl">
          <img src="/assets/logo-gestapelt.png" alt="Kanzlei Nabhan Gäbler &amp; Partner" className="h-36 w-auto mx-auto mb-8 select-none" draggable="false" data-testid="notfound-logo" />
          <p
            className="text-sm tracking-[0.3em] text-[#C9A87C] uppercase mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {t('notfound.error_label')}
          </p>
          <h1
            className="text-5xl sm:text-6xl text-[#0B2545] mb-6"
            style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
          >
            {t('notfound.heading')}
          </h1>
          <p
            className="text-base text-slate-600 mb-10 leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {t('notfound.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-[#0B2545] text-white tracking-wider uppercase text-sm hover:bg-[#0a1f3a] transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('notfound.button.home')}
            </Link>
            <Link
              to="/team"
              data-testid="not-found-team-link"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 border border-[#0B2545] text-[#0B2545] tracking-wider uppercase text-sm hover:bg-[#0B2545] hover:text-white transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('notfound.button.team')}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
